import React, { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { useLocation, Link } from 'react-router-dom';
import classnames from "classnames";
import {
  logo,
  whiteArrowDown
} from "../../assets/images";
import { removeUserDetails } from "../../dataSlice";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { MenuLinks } from "../../constants/MenuLinks";
import { URLS } from "../../constants/routes";
import { deleteAuthTokens } from "../../utils/localStorage";
import { useGlobalClick } from "../../utils/clickListener";
import { GetUserDetails } from "../../reduxData";
import Button from "../button";
import PresenceStatusPicker from "../../features/presence/PresenceStatusPicker";
import AutomatedChatToggle from "../../features/automatedChat/AutomatedChatToggle";
import "./Navbar.css";

export function useOnClickOutside(ref, handler) {

  useEffect(() => {
    const listener = (event) => {
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }
      handler(event);
    };
    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);
    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [ref, handler]);
}

let Navbar = ({ userClient }) => {
  const location = useLocation();
  const dispatch = useDispatch()
  const { instance, accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated()
  const logoutRequest = {
    account: accounts[0],
    // mainWindowRedirectUri was popup-only, not needed for logoutRedirect.
  };
  const userDetails = GetUserDetails();

  const logout = async () => {
    console.log("[Navbar][diag] logout() clicked");
    deleteAuthTokens()
    dispatch(removeUserDetails())
    try {
      // Redirect, not popup (matches login flow).
      await instance.logoutRedirect(logoutRequest)
    } catch (err) {
      console.error("[Navbar][diag] logoutRedirect failed:",
        err?.errorCode || err?.name, "|", err?.message);
    }
  }

  const [openNavbar, setOpenNavbar] = useState(false);
  const openNavbarRef = useRef(null);

  const handleClick = (event) => {
    if (openNavbarRef?.current && !openNavbarRef?.current?.contains(event.target)) {
      setOpenNavbar(false);
    }
    return
  };

  useGlobalClick(handleClick, openNavbarRef);

  return (
    <div className="container-fluid newNavbarContainer d-flex align-items-center justify-content-between">
      <div className="d-flex ">
        <Link to={URLS.DASHBOARD}>
          <img className="NavbarBrandLogo" src={logo} alt="logo" />
        </Link>
        {
          isAuthenticated &&
          <div className="d-flex align-items-center">
            {
              MenuLinks.filter((m) => userDetails.isManager || m.name !== "Content Management").map((links, idx) => (
                <React.Fragment key={idx}>
                  <Link
                    // to={links.external ? ""  : links?.path}
                    to={links.external ? "" : links?.subMenu ? window.location.pathname : links?.path}
                    key={links.name}
                    className={classnames(
                      links.external ? "NewNavBarLinks" :
                        location.pathname === links?.path ||
                          location.pathname?.split("/")[1] === links?.path?.split("/")[1]
                          ? "NewNavBarLinks NewNavBarLinksActive"
                          : "NewNavBarLinks"
                    )
                    }
                    onClick={(e) => {
                      if (links.subMenu) {
                        setOpenNavbar(!openNavbar)
                      }
                    }
                    }
                  >
                    {links.name}
                    <span className="position-relative">
                      {
                        links?.subMenu &&
                        <img
                          src={whiteArrowDown}
                          alt="toggle"
                          className={classnames("navSubMenuChevron", { open: openNavbar })}
                        />
                      }
                    </span>
                    {
                      (links?.subMenu && openNavbar) ?
                        <div className="subMenuBar">
                          {
                            links.subMenu.map((subLinks, index) => {
                              return (
                                <React.Fragment key={index}>
                                  <Link to={subLinks.path} className={classnames("subMenuLinks", location.pathname === subLinks?.active ? "subMenuActiveLink" : "")}>
                                    {subLinks.name}
                                  </Link>
                                  <br />
                                </React.Fragment>
                              )
                            })
                          }
                        </div>
                        : ""
                    }
                  </Link>
                </React.Fragment>
              ))
            }
          </div>
        }
      </div>
      {
        isAuthenticated &&
        <div className="d-flex align-items-center">
          <AutomatedChatToggle />
          <PresenceStatusPicker />
          <Button
            label={"Logout"}
            type="submit"
            className="btn-blue "
            onClick={() => {
              logout();
              userClient?.shutdown();
            }}
          />
        </div>
      }
    </div>

  );
};
export default Navbar;
